export const state = {
  reloadNoticeToken: 0
};

export const mutations = {
  triggerReloadNotice(state) {
    state.reloadNoticeToken += 1;
  }
};

export const actions = {
  triggerReloadNotice({ commit }) {
    commit("triggerReloadNotice");
  }
};
